// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2CUi0","signatureButtonsRight":"ModalSign_signatureButtonsRight__baheB"};